import styled from '@emotion/styled'
import { InputAdornment, TextField } from '@mui/material'
import { fontSize, size } from '@styles/theme'
import { PiMagnifyingGlass, PiMagnifyingGlassBold } from 'react-icons/pi'

// const StyledTextField = styled(TextField)`
//   height: ${size(4)};
//   width: 70%;
//   border-radius: 100px;
//   border: 0.5px solid rgba(255,255,255, 0.1);
//   background-color: #141414;
//   display: flex;
//   align-items: center;
//   justify-content: center;
  
//   & .MuiInputBase-root {
//     font-size: ${fontSize('xs')};
//     height: ${size(4)};
//     color: lightgrey;

//     & ::placeholder {
//       text-align: center;
//       padding-right: ${size(2.25)}; // 18px offset for the start icon
//     }
//   }

//   & fieldset {
//     border: none !important;
//   }
// `
const StyledTextField = styled.div`
  height: ${size(4)};
  width: 70%;
  border-radius: 100px;
  border: 0.5px solid rgba(255,255,255, 0.1);
  background-color: #141414;
  display: flex;
  align-items: center;
  justify-content: center;
  
  & .MuiInputBase-root {
    font-size: ${fontSize('xs')};
    height: ${size(4)};
    color: lightgrey;

    & ::placeholder {
      text-align: center;
      padding-right: ${size(2.25)}; // 18px offset for the start icon
    }
  }

  & fieldset {
    border: none !important;
  }
`

const NavTextField = ({ placeholder, startIcon, children, ...rest }) => {
  return (
    <StyledTextField {...rest}>
      {children}
    </StyledTextField>
  )
}

export default NavTextField
